import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resources from './i18nResources';
const localPrefs = (() => {
  try {
    const raw = localStorage.getItem("retailmaps:regional-preferences");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
})();
const preferredLanguage =
  localPrefs?.language && localPrefs.language !== "auto"
    ? localPrefs.language
    : undefined;

export const i18nReady = i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ['en', 'nl', 'de', 'fr', 'es', 'it'],
    fallbackLng: 'en',
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    lng: preferredLanguage,
    defaultNS: 'translation', // 👈 alles staat in dit ene bestand
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['cookie'],
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
